import "../App.css"
import logo from "../assets/logo/logo.png";
import { useState } from "react";

export const Header = (props) => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const navLinks = [
        { href: "/", text: "HOME", isActive: props.homePg },
        { href: "/aia/universities", text: "UNIVERSITIES", isActive: props.uniPg },
        { href: "/news", text: "NEWS", isActive: props.newsPg },
        { href: "/aas/apply", text: "AAS" },
        { href: "/AGFA/apply", text: "AGFA" },
        // { href: "/contact", text: "GET HELP", isActive: props.contactPg }
    ];

    const navLinkStyle = {
        color: '#e8f4fd',
        fontWeight: 600,
        fontSize: '13px',
        textDecoration: 'none',
        padding: '8px 16px',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        letterSpacing: '0.6px',
        borderRadius: '6px',
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        textTransform: 'uppercase',
        border: '1px solid transparent'
    };

    const activeNavLinkStyle = {
        ...navLinkStyle,
        background: 'linear-gradient(135deg, #4a90e2 0%, #357abd 100%)',
        color: '#ffffff',
        boxShadow: '0 3px 10px rgba(74, 144, 226, 0.3)',
        border: '1px solid #5ba0f2'
    };

    const toggleDrawer = () => {
        setIsDrawerOpen(!isDrawerOpen);
    };

    const closeDrawer = () => {
        setIsDrawerOpen(false);
    };

    return (
        <>
            {/* <h1> ARTHUR INTERNATIONAL AGENCY <br /> (AIA)</h1> */}
            <div className="header" style={{
                position: 'sticky',
                top: 0,
                left: 0,
                width: '100%',
                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #1e3c72 100%)',
                color: '#fff',
                // padding: '12px 20px',
                padding: '1rem',
                zIndex: 1001,
                boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '16px',
                borderBottom: '2px solid #4a90e2',
                flexWrap: 'wrap',
                // height: '90px',
                // maxHeight:'120px'
            }}>
                {/* Logo and Title */}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '16px'
                }}>
                    <img src={logo} alt="logo" width="55px" style={{
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                        border: '2px solid #4a90e2',
                        backgroundColor: '#ffffff'
                    }} />
                    <h1 style={{
                        color: "#ffffff",
                        margin: 0,
                        fontSize: '1.8rem',
                        fontWeight: '700',
                        textAlign: 'center',
                        textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                        letterSpacing: '1px',
                        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
                    }}>
                        ARTHUR INTERNATIONAL AGENCY (AIA)
                    </h1>
                </div>

                {/* Mobile Menu Button */}
                <button
                    className="mobile-menu-btn"
                    style={{
                        background: 'rgba(74, 144, 226, 0.2)',
                        border: '1px solid rgba(74, 144, 226, 0.3)',
                        color: '#fff',
                        fontSize: '24px',
                        cursor: 'pointer',
                        padding: '8px',
                        borderRadius: '6px',
                        transition: 'all 0.3s ease',
                        width: '40px',
                        height: '40px',
                        display: 'none',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                    onClick={toggleDrawer}
                    onMouseOver={e => {
                        e.target.style.background = 'rgba(74, 144, 226, 0.3)';
                        e.target.style.transform = 'scale(1.05)';
                    }}
                    onMouseOut={e => {
                        e.target.style.background = 'rgba(74, 144, 226, 0.2)';
                        e.target.style.transform = 'scale(1)';
                    }}
                >
                    ☰
                </button>

                {/* Navigation Links */}
                <div className="nav-links-container" style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                }}>
                    {navLinks.map((link, index) => (
                        <a
                            key={index}
                            href={link.href}
                            style={link.isActive ? activeNavLinkStyle : navLinkStyle}
                            onMouseOver={e => {
                                if (!link.isActive) {
                                    e.target.style.background = 'linear-gradient(135deg, rgba(74, 144, 226, 0.15) 0%, rgba(74, 144, 226, 0.25) 100%)';
                                    e.target.style.color = '#4a90e2';
                                    e.target.style.transform = 'translateY(-2px)';
                                    e.target.style.boxShadow = '0 4px 12px rgba(74, 144, 226, 0.2)';
                                    e.target.style.border = '1px solid rgba(74, 144, 226, 0.3)';
                                } else {
                                    e.target.style.background = 'linear-gradient(135deg, #5ba0f2 0%, #4a90e2 100%)';
                                    e.target.style.transform = 'translateY(-2px)';
                                    e.target.style.boxShadow = '0 5px 15px rgba(74, 144, 226, 0.4)';
                                }
                            }}
                            onMouseOut={e => {
                                if (!link.isActive) {
                                    e.target.style.background = 'transparent';
                                    e.target.style.color = '#e8f4fd';
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = 'none';
                                    e.target.style.border = '1px solid transparent';
                                } else {
                                    e.target.style.background = 'linear-gradient(135deg, #4a90e2 0%, #357abd 100%)';
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 3px 10px rgba(74, 144, 226, 0.3)';
                                }
                            }}
                        >
                            {link.text}
                        </a>
                    ))}
                </div>

                {/* Action Buttons */}
                <div className="action-buttons" style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                }}>
                    {/* WhatsApp Button */}
                    <a
                        href="https://wa.me/+8619572907062"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            background: 'linear-gradient(135deg, #25D366 0%, #128C7E 50%, #075E54 100%)',
                            color: '#ffffff',
                            fontWeight: 700,
                            borderRadius: '8px',
                            padding: '8px 16px',
                            textDecoration: 'none',
                            boxShadow: '0 3px 12px rgba(37, 211, 102, 0.3), inset 0 1px 0 rgba(255,255,255,0.2)',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            fontSize: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            border: '1px solid #25D366',
                            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                        }}
                        onMouseOver={e => {
                            e.target.style.background = 'linear-gradient(135deg, #25D366 0%, #128C7E 50%, #25D366 100%)';
                            e.target.style.transform = 'translateY(-2px) scale(1.05)';
                            e.target.style.boxShadow = '0 5px 16px rgba(37, 211, 102, 0.4)';
                        }}
                        onMouseOut={e => {
                            e.target.style.background = 'linear-gradient(135deg, #25D366 0%, #128C7E 50%, #075E54 100%)';
                            e.target.style.transform = 'translateY(0) scale(1)';
                            e.target.style.boxShadow = '0 3px 12px rgba(37, 211, 102, 0.3), inset 0 1px 0 rgba(255,255,255,0.2)';
                        }}
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '6px' }}>
                            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488" />
                        </svg>
                        CHAT
                    </a>

                    {/* Apply Button */}
                    <a
                        href="/apply"
                        target="_blank"
                        style={{
                            background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 50%, #e9ecef 100%)',
                            color: '#1a1a2e',
                            fontWeight: 700,
                            borderRadius: '8px',
                            padding: '8px 20px',
                            textDecoration: 'none',
                            boxShadow: '0 3px 12px rgba(0,0,0,0.15), inset 0 1px 0 rgba(255,255,255,0.8)',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            fontSize: '12px',
                            border: '2px solid #4a90e2',
                            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                        }}
                        onMouseOver={e => {
                            e.target.style.background = 'linear-gradient(135deg, #4a90e2 0%, #357abd 50%, #4a90e2 100%)';
                            e.target.style.color = '#ffffff';
                            e.target.style.transform = 'translateY(-2px) scale(1.05)';
                            e.target.style.boxShadow = '0 5px 16px rgba(74, 144, 226, 0.4)';
                        }}
                        onMouseOut={e => {
                            e.target.style.background = 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 50%, #e9ecef 100%)';
                            e.target.style.color = '#1a1a2e';
                            e.target.style.transform = 'translateY(0) scale(1)';
                            e.target.style.boxShadow = '0 3px 12px rgba(0,0,0,0.15), inset 0 1px 0 rgba(255,255,255,0.8)';
                        }}
                    >
                        APPLY
                    </a>
                </div>
            </div>

            {/* Mobile Drawer */}
            <div
                className="mobile-drawer-overlay"
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 999,
                    opacity: isDrawerOpen ? 1 : 0,
                    visibility: isDrawerOpen ? 'visible' : 'hidden',
                    transition: 'all 0.3s ease',
                    backdropFilter: 'blur(4px)',
                    WebkitBackdropFilter: 'blur(4px)'
                }}
                onClick={closeDrawer}
            >
                <div
                    className="mobile-drawer"
                    style={{
                        position: 'fixed',
                        top: 0,
                        right: 0,
                        width: '280px',
                        height: '100%',
                        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 25%, #0f3460 50%, #16213e 75%, #1a1a2e 100%)',
                        boxShadow: '-4px 0 20px rgba(0, 0, 0, 0.3)',
                        transform: isDrawerOpen ? 'translateX(0)' : 'translateX(100%)',
                        transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        zIndex: 1000,
                        padding: '20px',
                        display: 'flex',
                        flexDirection: 'column',
                        borderLeft: '2px solid #4a90e2'
                    }}
                    onClick={e => e.stopPropagation()}
                >
                    {/* Drawer Header */}
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: '30px',
                        paddingBottom: '20px',
                        borderBottom: '1px solid rgba(74, 144, 226, 0.3)'
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px'
                        }}>
                            <img src={logo} alt="logo" width="40px" style={{
                                borderRadius: '6px',
                                border: '1px solid #4a90e2'
                            }} />
                            <span style={{
                                color: '#ffffff',
                                fontSize: '16px',
                                fontWeight: '600',
                                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
                            }}>
                                AIA
                            </span>
                        </div>
                        <button
                            onClick={closeDrawer}
                            style={{
                                background: 'rgba(74, 144, 226, 0.2)',
                                border: '1px solid rgba(74, 144, 226, 0.3)',
                                color: '#fff',
                                fontSize: '20px',
                                cursor: 'pointer',
                                padding: '8px',
                                borderRadius: '6px',
                                transition: 'all 0.3s ease',
                                width: '36px',
                                height: '36px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                            onMouseOver={e => {
                                e.target.style.background = 'rgba(74, 144, 226, 0.3)';
                                e.target.style.transform = 'scale(1.05)';
                            }}
                            onMouseOut={e => {
                                e.target.style.background = 'rgba(74, 144, 226, 0.2)';
                                e.target.style.transform = 'scale(1)';
                            }}
                        >
                            ✕
                        </button>
                    </div>

                    {/* Drawer Navigation Links */}
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                        marginBottom: '30px'
                    }}>
                        {navLinks.map((link, index) => (
                            <a
                                key={index}
                                href={link.href}
                                onClick={closeDrawer}
                                style={{
                                    color: link.isActive ? '#4a90e2' : '#e8f4fd',
                                    fontWeight: link.isActive ? '700' : '600',
                                    fontSize: '16px',
                                    textDecoration: 'none',
                                    padding: '16px 20px',
                                    borderRadius: '8px',
                                    transition: 'all 0.3s ease',
                                    background: link.isActive ? 'rgba(74, 144, 226, 0.15)' : 'transparent',
                                    border: link.isActive ? '1px solid rgba(74, 144, 226, 0.3)' : '1px solid transparent',
                                    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px'
                                }}
                                onMouseOver={e => {
                                    if (!link.isActive) {
                                        e.target.style.background = 'rgba(74, 144, 226, 0.1)';
                                        e.target.style.color = '#4a90e2';
                                        e.target.style.transform = 'translateX(8px)';
                                    }
                                }}
                                onMouseOut={e => {
                                    if (!link.isActive) {
                                        e.target.style.background = 'transparent';
                                        e.target.style.color = '#e8f4fd';
                                        e.target.style.transform = 'translateX(0)';
                                    }
                                }}
                            >
                                {link.text}
                            </a>
                        ))}
                    </div>

                    {/* Drawer Action Buttons */}
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '12px',
                        marginTop: 'auto'
                    }}>
                        <a
                            href="https://wa.me/+8619572907062"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={closeDrawer}
                            style={{
                                background: 'linear-gradient(135deg, #25D366 0%, #128C7E 50%, #075E54 100%)',
                                color: '#ffffff',
                                fontWeight: '700',
                                borderRadius: '8px',
                                padding: '16px 20px',
                                textDecoration: 'none',
                                boxShadow: '0 4px 12px rgba(37, 211, 102, 0.3)',
                                transition: 'all 0.3s ease',
                                fontSize: '14px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: '1px solid #25D366',
                                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px'
                            }}
                            onMouseOver={e => {
                                e.target.style.transform = 'translateY(-2px)';
                                e.target.style.boxShadow = '0 6px 16px rgba(37, 211, 102, 0.4)';
                            }}
                            onMouseOut={e => {
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = '0 4px 12px rgba(37, 211, 102, 0.3)';
                            }}
                        >
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: '8px' }}>
                                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488" />
                            </svg>
                            CHAT WITH US
                        </a>
                        <a
                            href="/apply"
                            target="_blank"
                            onClick={closeDrawer}
                            style={{
                                background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 50%, #e9ecef 100%)',
                                color: '#1a1a2e',
                                fontWeight: '700',
                                borderRadius: '8px',
                                padding: '16px 20px',
                                textDecoration: 'none',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                transition: 'all 0.3s ease',
                                fontSize: '14px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: '2px solid #4a90e2',
                                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px'
                            }}
                            onMouseOver={e => {
                                e.target.style.background = 'linear-gradient(135deg, #4a90e2 0%, #357abd 50%, #4a90e2 100%)';
                                e.target.style.color = '#ffffff';
                                e.target.style.transform = 'translateY(-2px)';
                                e.target.style.boxShadow = '0 6px 16px rgba(74, 144, 226, 0.4)';
                            }}
                            onMouseOut={e => {
                                e.target.style.background = 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 50%, #e9ecef 100%)';
                                e.target.style.color = '#1a1a2e';
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                            }}
                        >
                            APPLY NOW
                        </a>
                    </div>
                </div>
            </div>

            {/* Responsive CSS Styles */}
            <style>{`
                @media (max-width: 1024px) {
                    .header h1 { font-size: 1.4rem !important; }
                    .nav-links-container { gap: 4px !important; }
                    .nav-links-container a { padding: 6px 12px !important; font-size: 11px !important; }
                    .action-buttons a { padding: 6px 12px !important; font-size: 11px !important; }
                }
                @media (max-width: 768px) {
                    .header { 
                        padding: 8px 12px !important; 
                        justify-content: space-between !important;
                    }
                    .header h1 { font-size: 1.1rem !important; text-align: center !important; }
                    .header img { width: 40px !important; }
                    .mobile-menu-btn { 
                        display: flex !important; 
                        position: relative !important;
                        top: auto !important;
                        right: auto !important;
                    }
                    .nav-links-container { display: none !important; }
                    .action-buttons { display: none !important; }
                }
                @media (max-width: 480px) {
                    .header { padding: 6px 8px !important; }
                    .header h1 { font-size: 0.9rem !important; }
                    .header img { width: 35px !important; }
                    .mobile-menu-btn { 
                        width: 36px !important; 
                        height: 36px !important; 
                        font-size: 20px !important;
                    }
                }
                @media (max-width: 360px) {
                    .header h1 { font-size: 0.8rem !important; }
                    .header img { width: 30px !important; }
                    .mobile-menu-btn { 
                        width: 32px !important; 
                        height: 32px !important; 
                        font-size: 18px !important;
                    }
                }
                
                /* Mobile Drawer Specific Styles */
                @media (max-width: 768px) {
                    .mobile-drawer {
                        width: 280px !important;
                    }
                }
                @media (max-width: 480px) {
                    .mobile-drawer {
                        width: 260px !important;
                    }
                }
                @media (max-width: 360px) {
                    .mobile-drawer {
                        width: 240px !important;
                    }
                }
            `}</style>
        </>
    )
}